import {mapGetters} from "vuex";
import {Loading} from "element-ui";

export default {
    props: {
        dialog: Boolean,
    },
    data() {
        return {
            loadDialog: undefined
        }
    },
    computed: {
        ...mapGetters({
            dialogFullscreen: 'dialogFullscreen',
            labelPosition: 'labelPosition',
        }),
    },
    methods: {
        loadStart() {
            this.loadDialog = Loading.service({
                target: document.getElementById(this.$options.name).getElementsByClassName("el-dialog")[0]
            });
        },
        fetchNoDialog() {
            const parentName = this.$parent.$options.name;
            const dialogName = this.$options.name;
            this.refresh.$emit(parentName, function () {
                this.fetchData();
                this[dialogName] = false;
            })
        },
        noDialog() {
            // const name = this.$parent.$options.name;
            const name = this.$options.name;
            this.refresh.$emit(name, function () {
                this[name] = false;
            })
        },
    },
    mounted() {
        let name = this.$options.name;
        if (name){
            this.refresh.$on(name, (callBack) => {
                if (typeof callBack === "function") {
                    callBack.call(this.$parent)
                }
            });
        }
    },
}
